import { Heart, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CharacterPlaceholderProps {
  name: string;
  id?: number;
  className?: string;
}

export const CharacterPlaceholder = ({ name, id = 1, className = "" }: CharacterPlaceholderProps) => {
  const { t } = useTranslation('characters');
  // Generate unique gradient based on ID
  const gradients = [
    'from-brand-primary to-brand-primary-dark',
    'from-brand-secondary to-brand-primary',
    'from-error to-brand-primary',
    'from-brand-secondary to-brand-secondary',
    'from-brand-secondary to-brand-secondary',
    'from-brand-secondary to-brand-primary',
    'from-brand-primary to-error',
    'from-brand-secondary to-brand-primary-dark',
  ];
  
  const gradient = gradients[id % gradients.length];
  
  // Initialen aus dem Namen berechnen (max. 2 Buchstaben)
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join('') || 'C';

  return (
    <div className={`relative w-full h-full bg-gradient-to-br ${gradient} ${className}`}>
      <div className="absolute inset-0 bg-black/20" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-white/80 select-none" aria-hidden>
          <span className="block tracking-widest" style={{ fontSize: '64px', lineHeight: 1 }}>
            {initials}
          </span>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-token-sm bg-gradient-to-t from-black/60 to-transparent">
        <p className="text-white/70 text-center text-xs font-medium">{t('profile.noImage')}</p>
      </div>
    </div>
  );
};